import { ColumnDefinition, NumberField, Table } from '@approvalmax/ui/src/components';
import { netSuiteConstants } from 'modules/common/constants';

import { SubsidiaryTableItem } from '../../NetSuiteVendorCreationPopupContent.types';
import { SubsidiaryCell } from '../SubsidiaryCell/SubsidiaryCell';
import { TaxCodeCell } from '../TaxCodeCell/TaxCodeCell';
import { messages } from './SubsidiariesInformation.messages';
import { GetColumnDefinitionParams } from './SubsidiariesInformation.types';

export const getColumnDefinition = (params: GetColumnDefinitionParams) => {
    const { control, subsidiaries, currenciesMap } = params;

    return [
        {
            id: 'subsidiaryId',
            name: messages.subsidiaries,
            minWidth: 200,
            cellComponent: (props) => (
                <SubsidiaryCell
                    {...props}
                    name={`subsidiaries.${props.item.index}.subsidiaryId`}
                    subsidiaries={subsidiaries}
                    columnSpacing='4 8'
                />
            ),
        },
        {
            id: 'creditLimit',
            name: messages.creditLimit,
            minWidth: 200,
            cellComponent: (props) => {
                const subsidiary = subsidiaries.find(({ id }) => id === props.item.subsidiaryId);

                const currencyPrecision = currenciesMap.get(subsidiary?.currencyInternalId)?.precision ?? 2;

                return (
                    <Table.FormCell
                        {...props}
                        name={`subsidiaries.${props.item.index}.creditLimit`}
                        columnSpacing='4 8'
                    >
                        {({ name, ref }) => (
                            <NumberField
                                name={name}
                                ref={ref}
                                placeholder={messages.inputPlaceholder}
                                bordered={false}
                                size='small'
                                precision={currencyPrecision}
                                min={0}
                                max={netSuiteConstants.maxCreditLimit}
                            />
                        )}
                    </Table.FormCell>
                );
            },
        },
        {
            id: 'taxCodeId',
            name: messages.taxCode,
            minWidth: 200,
            cellComponent: (props) => (
                <TaxCodeCell
                    {...props}
                    name={`subsidiaries.${props.item.index}.taxCodeId`}
                    control={control}
                    subsidiaryIdName={`subsidiaries.${props.item.index}.subsidiaryId`}
                    columnSpacing='4 8'
                />
            ),
        },
    ] as ColumnDefinition<SubsidiaryTableItem>[];
};
